import { GlobalBus } from '@services/bus'

const defaultSnackModal = {
  text: '',
  close: true,
  timeout: 8000,
  color: 'default',
  button: true,
}

const toSnackModal = (payload) => {
  const getColorMap = (status) => {
    if (!status) return 'default'

    const firstDigit = String(status)[0]

    const colorMap = {
      2: 'success',
      4: 'warning',
      5: 'error',
    }

    return colorMap[firstDigit] || 'default'
  }

  const obligateFields = {
    text: payload.text || payload.message || '',
    color: payload.color || getColorMap(payload.status),
  }

  return { ...defaultSnackModal, ...payload, ...obligateFields }
}

const toSnack = (payload) => {
  if (!payload) return payload

  if (payload.status === undefined) return payload

  const getSnackColor = (status) => {
    if (!status) return null
    const firstDigit = String(status)[0]
    if (firstDigit === '2') return 'success'
    return 'error'
  }

  return {
    ...payload,
    text: payload.text || payload.message || 'Erro inesperado',
    color: payload.color || getSnackColor(payload.status),
    button: payload.button === undefined ? true : payload.button,
  }
}

const SHOW_SNACKBAR = (state, payload) => {
  state.snackbar = { ...toSnack(payload), show: true }
}

const CLOSE_SNACKBAR = (state) => {
  state.snackbar = {
    ...state.snackbar,
    show: false,
  }
}

const SHOW_MODAL = (state, payload) => {
  state.modal = { ...payload, show: true }
}

const CLOSE_MODAL = (state) => {
  state.modal = {
    ...state.modal,
    show: false,
  }
}

const ADD_QUEUE_SNACK_MODAL = (state, payload) => {
  if (payload) {
    state.queueSnackModal.push(toSnackModal(payload))
    GlobalBus.$emit('show-snack-modal')
  }
}

const REMOVE_FIRST_SNACK_MODAL = (state, payload) => {
  const first = state.queueSnackModal[0]

  if (first && JSON.stringify(first) === JSON.stringify(payload)) {
    state.queueSnackModal.splice(0, 1)
  }
}

export {
  SHOW_SNACKBAR,
  CLOSE_SNACKBAR,
  SHOW_MODAL,
  CLOSE_MODAL,
  ADD_QUEUE_SNACK_MODAL,
  REMOVE_FIRST_SNACK_MODAL,
}
